import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/icons/icon-notice.svg'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-bank" }
const _hoisted_3 = { class: "page-bank-table" }
const _hoisted_4 = {
  class: "page-bank-table-body-item col-1",
  style: {"line-height":"17px"}
}
const _hoisted_5 = { class: "page-bank-table-body-item col-2" }
const _hoisted_6 = { class: "page-bank-table-body-item col-3" }
const _hoisted_7 = { class: "page-content" }
const _hoisted_8 = { class: "page-content-text primary" }

import { reactive, computed } from 'vue'
import dayjs from 'dayjs'
import { useMutation } from '@vue/apollo-composable'
import { mutateApi } from '@/graphql/mutation'
import { useData } from '../transfer-pro/hooks'
import router from '@/router'
import { Message } from '@/components/Message'
import { RouterName } from '@/enum'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const state = reactive({
  bankInfo: [
    {
      bankName: '中国银行（香港）有限公司',
      bankCode: '012-81-9100-82663',
      currency: '港元',
      accountName: 'Goldhorse Securities Limited (Clients’ A/C)'
    },
    {
      bankName: '香港上海汇丰银行有限公司',
      bankCode: '741-515233-001',
      currency: '港元',
      accountName: 'Goldhorse Securities Limited -Clients’ Accounts'
    },
    {
      bankName: '创兴银行有限公司',
      bankCode: '256-20-9044323',
      currency: '港元',
      accountName: 'Goldhorse Securities Limited – Client Account'
    }
  ]
})

const after3Month = computed(() => dayjs().add(3, 'month').format('YYYY-MM-DD'))

const { mutate: saveInfo, onDone } = useMutation(mutateApi.openInfoSave)

const data = useData()

const handleSubmit = () => {
  console.log('data', data)
  const param = {
    ...data,
    depositStatus: 0,
    openAccountFundDeposit: null
  }
  saveInfo({ param })
}

onDone((res: any) => {
  const { ok, reason } = res?.data?.openInfoSave
  if (ok) {
    Message({ text: '提交成功', direction: 'vertical', type: 'success' })
    router.push({ name: RouterName.REASON_STATUS })
  } else {
    Message({ text: reason?.desc || '请求异常', direction: 'vertical' })
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page-head" }, [
      _createElementVNode("img", { src: _imports_0 }),
      _createElementVNode("div", { class: "page-head-title" }, "注意：阁下并未完成整个开户程序")
    ], -1)),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-tip" }, " 阁下需要将数额不少于10,000港元的首笔存款，由以阁下名义在香港持牌银行开立的银行户口成功转账至金马证券的银行户口 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page-bank-title" }, "其银行资料如下", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "page-bank-table-head" }, [
          _createElementVNode("div", { class: "page-bank-table-head-item col-1" }, "银行名称/银行号码"),
          _createElementVNode("div", { class: "page-bank-table-head-item col-2" }, "币种"),
          _createElementVNode("div", { class: "page-bank-table-head-item col-3" }, "账户名称")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.bankInfo, (v) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "page-bank-table-body",
            key: v.bankCode
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(v.bankName) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(v.bankCode), 1)
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(v.currency), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(v.accountName), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"page-content-text\" data-v-e6286eac>当完成转账后，阁下需要通过以下方式递交转账证明：</div><div class=\"page-content-text1\" data-v-e6286eac><div class=\"page-content-ball\" data-v-e6286eac>1</div><div class=\"page-content-text1-text\" data-v-e6286eac>登录APP或</div></div><div class=\"page-content-text1\" data-v-e6286eac><div class=\"page-content-ball\" data-v-e6286eac>2</div><div class=\"page-content-text1-text\" data-v-e6286eac>透过电子邮件</div></div><div class=\"page-content-text\" data-v-e6286eac> 若选择透过电子邮件方式，阁下需要把转账记录电邮至cs@goldhorse.com.hk，同时亦必须于转账证明文件上（否则我们可能会不接受阁下的指示）。 </div><div class=\"page-content-text\" data-v-e6286eac><div class=\"page-content-small-ball\" data-v-e6286eac></div><div data-v-e6286eac>写上阁下全名（需与阁下身份証明文件所显示一样）</div></div><div class=\"page-content-text\" data-v-e6286eac><div class=\"page-content-small-ball\" data-v-e6286eac></div><div data-v-e6286eac>写上阁下的联络电话</div></div><div class=\"page-content-text\" data-v-e6286eac><div class=\"page-content-small-ball\" data-v-e6286eac></div><div data-v-e6286eac>签署（阁下的签名式样需与开户申请记录一样）</div></div>", 7)),
      _createElementVNode("div", _hoisted_8, " 阁下需要于 " + _toDisplayString(after3Month.value) + " 完成上述转账及递交转账证明，否则阁下的开户申请将会作废，相关资料亦将会永久删除。 ", 1),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "page-content-text" }, " 若有任何疑问，请致电服务热线（852）2153 3838 或电邮至cs@goldhorse.com.hk，与我们查询。 ", -1))
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: handleSubmit
    }, "提交申请")
  ]))
}
}

})